var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCalendarNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "26px",
    viewBox: "0 0 21 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 50") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shipment1-Copy-2",
    transform: "translate(-778.000000, -737.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(778.000000, 737.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29-Copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,2.5 C1.44771525,2.5 1,2.94771525 1,3.5 L1,23.5 C1,24.0522847 1.44771525,24.5 2,24.5 L19,24.5 C19.5522847,24.5 20,24.0522847 20,23.5 L20,3.5 C20,2.94771525 19.5522847,2.5 19,2.5 L2,2.5 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4,
    y: 1,
    width: 1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 10,
    y: 1,
    width: 1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 16,
    y: 1,
    width: 1,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(4.500000, 8.873535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.5 L12,0.5",
    id: "Path-113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5.12646484 L7.95019531,5.12646484",
    id: "Path-113-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10.1264648 L10.5,10.1264648",
    id: "Path-113-Copy-2"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalendarNote);
export default __webpack_public_path__ + "static/media/ico_calendar_note.74c7876ae8a3a0371bef80b4ab675afb.svg";
export { ForwardRef as ReactComponent };